export const ADMIN = '667e8ce07ebe3efded66e92d'
export const GURUDWARA_ADMIN = '66b9a6a76be56b5275881bbb'
